import axios from 'axios'
const CancelToken = axios.CancelToken

export default {
  get: function (url, options = {}, oauth = true) {
    return this.doRequest('get', url, {}, options, false, oauth)
  },
  post: function (url, body = {}, options = {}, oauth = true) {
    return this.doRequest('post', url, body, options, true, oauth)
  },
  put: function (url, body = {}, options = {}, oauth = true) {
    return this.doRequest('put', url, body, options, true, oauth)
  },
  delete: function (url, options = {}, oauth = true) {
    return this.doRequest('delete', url, {}, options, false, oauth)
  },
  addInterceptor: fn => axios.interceptors.request.use(fn),
  doRequest: function (type, url, body, options, hasBody, oauth) {
    return new Promise((resolve, reject) => {
      if (!options.hasOwnProperty('headers')) {
        options.headers = {}
      }
      if (!options.headers.hasOwnProperty('Authorization') && oauth) {
        options.headers['Authorization'] = `Bearer ${window.localStorage.getItem('token')}`
      }
      this.getRequest(hasBody, type, url, body, options).then(resolve).catch(reject)
    })
  },
  clear: function () {
    return new Promise((resolve, reject) => {
      this.inFlight.forEach(cancel => cancel())
      this.inFlight = []
      resolve()
    })
  },
  inFlight: [],
  activeRequest: false,
  getRequest: function (hasBody, type, url, body, options) {
    return hasBody ? axios[type](url, this.transform(body), {
      ...options,
      cancelToken: new CancelToken((c) => {
        this.inFlight.push(c)
      })
    }) : axios[type](url, {
      ...options,
      cancelToken: new CancelToken((c) => {
        this.inFlight.push(c)
      })
    })
  },
  transform: function (data) {
    if (typeof data === 'object') {
      for (let prop in data) {
        let timestamp = data[prop]
        if (String(timestamp).match(/^(....)-(..)-(..)/) && !timestamp.endsWith('Z')) {
          data[prop] = `${timestamp}T00:00:00Z`
        }
      }
    }
    return data
  }
}



// WEBPACK FOOTER //
// ./src/http/index.js